import { render, staticRenderFns } from "./ProjectDetailsInfo.vue?vue&type=template&id=5b949f32&scoped=true"
import script from "./ProjectDetailsInfo.vue?vue&type=script&lang=js"
export * from "./ProjectDetailsInfo.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailsInfo.vue?vue&type=style&index=0&id=5b949f32&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b949f32",
  null
  
)

export default component.exports